export default __webpack_public_path__ + "static/media/2406.f736d65e.png";